import React from 'react';
import {createBrowserRouter} from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home/Home';
import QuestMap from './pages/QuestMap/QuestMap';
import Gallery from './pages/Gallery/Gallery';
import Profile from './pages/Profile/Profile';
import Login from './pages/Login/Login';
import Lab from './pages/Lab/Lab';
import AdminCourses from './pages/AdminCourses/AdminCourses';
import Placeholder from './pages/Placeholder/Placeholder';

// 全站路由表
export const router = createBrowserRouter([
    {
        element: <Layout />,
        children: [
            {path: '/', element: <Home />},
            {path: '/quests', element: <QuestMap />},
            {path: '/gallery', element: <Gallery />},
            {path: '/profile', element: <Profile />},
            {path: '/login', element: <Login />},
            {path: '/admin/courses', element: <AdminCourses />},
            {path: '/lab/:questId?', element: <Lab />},
            {path: '/terms', element: <Placeholder page="terms" />},
            {path: '/privacy', element: <Placeholder page="privacy" />},
            {path: '/safety', element: <Placeholder page="safety" />},
            {path: '/support', element: <Placeholder page="support" />},
            {path: '*', element: <Placeholder title="迷路啦" hint="这里什么都没有，我们回首页看看吧。" />}
        ]
    }
]);
